import { connect } from 'react-redux';
import Main from './main';
import { loadOrders } from '../reducers/order.reducers';
import { loadUiOptions } from '../reducers/app.reducers';

const mapStateToProps = state => ({
  title: state.navigator.title,
  loggedIn: state.authentication.loggedIn,

});

const mapDispatchToProps = dispatch => ({
  loadOrders: () => dispatch(loadOrders()),
  loadUiOptions: () => dispatch(loadUiOptions()),
  // subscribeForOrderUpdates: () => dispatch(subscribeForOrderUpdates()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Main);
